export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-crop-15f1b94161d4f876391e2e2f1f573da9.svg";